// @flow
import type {ListingShape} from '../components/Hit/Hit';

export const listingHasPrice = (listing: ListingShape): boolean => {
    const {priceSummary} = listing || {};
    return !!priceSummary;
};
